export default {
    topics: [
        {
            title: ' FTP (Class) ',
            href: 'c-FTP.html',
            attributes: { 'data-id': 'c-FTP' },
            menu: { hasChildren: false },
            tocID: 'c-FTP-d66e5321',
            next: 'c-FTP-d66e5321',
        },
        {
            title: ' HttpClientRequest (Class) ',
            href: 'c-HttpClientRequest.html',
            attributes: { 'data-id': 'c-HttpClientRequest' },
            menu: { hasChildren: false },
            tocID: 'c-HttpClientRequest-d66e5377',
            next: 'c-HttpClientRequest-d66e5377',
        },
        {
            title: ' HttpClientResponse (Class) ',
            href: 'c-HttpClientResponse.html',
            attributes: { 'data-id': 'c-HttpClientResponse' },
            menu: { hasChildren: false },
            tocID: 'c-HttpClientResponse-d66e5474',
            next: 'c-HttpClientResponse-d66e5474',
        },
        {
            title: ' HttpSoapConnection (Class) ',
            href: 'c-HttpSoapConnection.html',
            attributes: { 'data-id': 'c-HttpSoapConnection' },
            menu: { hasChildren: false },
            tocID: 'c-HttpSoapConnection-d66e5530',
            next: 'c-HttpSoapConnection-d66e5530',
        },
        {
            title: ' SoapService (Class) ',
            href: 'c-SoapService.html',
            attributes: { 'data-id': 'c-SoapService' },
            menu: { hasChildren: false },
            tocID: 'c-SoapService-d66e5570',
            next: 'c-SoapService-d66e5570',
        },
    ],
};

